import React, { useState } from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import {
    Box,
    Button,
    Card as MuiCard,
    CardContent,
    TextField,
    Typography,
    Snackbar,
    Alert
} from "@mui/material";
import { spacing } from "@mui/system";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import PublicListagemFaturas from "./list-pending";

const Card = styled(MuiCard)(spacing);

export default function PublicConsultarFaturas() {
    const { configuration } = useAuth();

    const navigate = useNavigate();
    const [tax_identifier, setDocumento] = useState("");

    const [showInvoice, setShowInvoice] = useState(false);

    const [erro, setErro] = useState("");

    // Função simples de máscara ou validação básica de CPF/CNPJ
    const handleDocumentoChange = (e) => {
        setShowInvoice(false);
        let valor = e.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos

        // Limita o tamanho máximo para CNPJ (14 dígitos)
        if (valor.length > 14) {
            valor = valor.slice(0, 14);
        }

        setDocumento(valor);
    };

    const handleConsultar = (e) => {
        e.preventDefault();

        if (!tax_identifier || (tax_identifier.length !== 11 && tax_identifier.length !== 14)) {
            setErro("Por favor, informe um CPF (11 dígitos) ou CNPJ (14 dígitos) válido.");
            return;
        }

        setErro("");
        // Redireciona para a tela de listagem de faturas passando o documento via query param ou estado
        // Exemplo: navigate(`/minhas-faturas/listagem?tax_identifier=${tax_identifier}`);
        console.log("Consultando faturas para o documento:", tax_identifier);
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Minhas Faturas - Consultar Faturas | Cachê Bank</title>
            </Helmet>

            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="80vh"
                p={3}
            >

                {
                    configuration &&
                    (
                        configuration.brandmark ?
                            <center><img src={configuration.brandmark} width="250" height="150" /></center>
                            :
                            <center>
                                <Typography variant="h4" gutterBottom fontWeight="bold">
                                    {configuration.website_name}
                                </Typography>
                            </center>

                    )

                }
                <br></br>

                <Typography variant="body1" color="textSecondary" gutterBottom mb={2} hidden={showInvoice}>
                    Informe seu CPF ou CNPJ para acessar e visualizar suas faturas pendentes.
                </Typography>

                <Card mb={6} sx={{ maxWidth: 450, width: "100%", boxShadow: 3 }} hidden={showInvoice}>
                    <CardContent>
                        <form onSubmit={handleConsultar}>
                            <TextField
                                type="text"
                                label="CPF ou CNPJ"
                                value={tax_identifier}
                                onChange={handleDocumentoChange}
                                placeholder="Digite apenas números"
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                error={Boolean(erro)}
                            />
                            {erro && (
                                <Typography variant="caption" color="error" display="block" mt={1}>
                                    {erro}
                                </Typography>
                            )}

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                size="large"
                                sx={{ mt: 3 }}
                                onClick={e => setShowInvoice(true)}
                            >
                                Continuar / Consultar Faturas
                            </Button>
                        </form>

                    </CardContent>

                </Card>
                {showInvoice &&
                    <PublicListagemFaturas
                        showInvoice={showInvoice}
                        setShowInvoice={setShowInvoice}
                        tax_identifier={tax_identifier}
                    />}
            </Box>
        </React.Fragment>
    );
}